module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1fdd09a87b58a90cfa9.worker.js");
};